import React, { useEffect, useRef } from "react";

// Wrap a section in this to fade it in on scroll into view.
export const Reveal = ({ children, className = "", delay = 0, as: Tag = "div", testId }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => el.classList.add("is-visible"), delay);
            obs.unobserve(el);
          }
        });
      },
      { threshold: 0.15 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [delay]);

  return (
    <Tag ref={ref} className={`kek-reveal ${className}`} data-testid={testId}>
      {children}
    </Tag>
  );
};

export default Reveal;
